var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo-container"},[_c('v-img',{staticClass:"logo",attrs:{"max-width":"50%","lazy-src":require('@/assets/images/logo_lazy.png'),"src":require('@/assets/images/logo.png')},on:{"click":function($event){return _vm.$router.push('/')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }